import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import PageHeader from '@spark/ui-components/components/BreadCrumb';
import { useMotoristaListagem } from './hooks/useMotoristaListagem';
import { useMotoristaNavegacao } from './hooks/useMotoristaNavegacao';
import {
  MotoristaCard,
  MotoristaHeader,
  MotoristaFilter,
  MotoristaTable,
} from './components';

const MotoristaListagem = () => {
  const {
    data,
    loading,
    filterLoading,
    totalRegistros,
    paginationState,
    setPaginationState,
    handleFilterApply,
    handleLimparFiltros,
  } = useMotoristaListagem();

  const { handleNovo, handleVisualizar } = useMotoristaNavegacao();

  return (
    <Container fluid>
      <Row>
        <Col md={12}>
          <PageHeader
            title=""
            routeSegments={[{ name: 'Inicio' }, { name: 'Motoristas' }]}
          />
        </Col>
      </Row>

      <Row>
        <Col md={12}>
          <MotoristaCard>
            <MotoristaHeader
              totalRegistros={totalRegistros}
              onNovo={handleNovo}
            />

            <MotoristaFilter
              loading={filterLoading}
              onApply={handleFilterApply}
              onLimpar={handleLimparFiltros}
            />

            <MotoristaTable
              data={data}
              loading={loading}
              onRowClick={handleVisualizar}
              totalRegistros={totalRegistros}
              paginationState={paginationState}
              setPaginationState={setPaginationState}
            />
          </MotoristaCard>
        </Col>
      </Row>
    </Container>
  );
};

export default MotoristaListagem;
